/* SLIDER CONSTANTS */

export const DEFAULT_STEP = 56;
export const DEFAULT_CONTAINER_ID = 'containerElement';
export const DIRECTION_UP = 'up';
export const DIRECTION_DOWN = 'down';
export const SCROLL_TO_DEFAULT_SECTION = 'segment-part-two';
export const SECOND_PART_SEGMENT_INDEX = 5;
export const NO_SCROLL_ANIMATION_DURATION = 0;
export const SCROLL_ANIMATION_DURATION = 1000;
export const SCROLL_BUTTON_HIGHLIGHTED = 'pulse';
